import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { ICPDEnrollment } from 'src/interfaces/bundle';

import { ListCourseBox } from './style';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

interface Props {
  bundle: ICPDEnrollment[];
  roundDate: number;
  startTrainRoundDate?: string | Date | null;
  endTrainRoundDate?: string | Date | null;
  handleClickChooseRound: (data: ICPDEnrollment) => void;
}

const ListSameCourseCpd = ({
  bundle,
  roundDate,
  startTrainRoundDate,
  endTrainRoundDate,
  handleClickChooseRound,
}: Props) => {
  const { t } = useTranslation();

  const onClick = () => {
    handleClickChooseRound(bundle[0]);
  };

  const isSelectRound = Boolean(startTrainRoundDate && endTrainRoundDate);
  const buttonText = isSelectRound
    ? t('cpd_enrollment.edit_training_session')
    : t('cpd_enrollment.choose_training_session');

  return (
    <ListCourseBox isSelectRound={isSelectRound}>
      <Box>
        {bundle.map((item, index) => (
          <Typography className="title-text">
            {index + 1}. {item.courseName}
          </Typography>
        ))}
      </Box>
      <Box className="round-info-box">
        <Typography className="round-date-text" color="rgba(0, 0, 0, 0.6)">
          {`${t('cpd_enrollment.round_date')}: ${roundDate} ${t('cpd_enrollment.day')}`}
        </Typography>
        <Typography className="round-date-text">
          {`${t('cpd_enrollment.round_start_date')}: `}
          <Typography
            className="round-date-text"
            component="span"
            sx={{
              color: startTrainRoundDate ? 'black' : 'errorDark.main',
            }}
          >
            {startTrainRoundDate
              ? t('cpd_enrollment.round.selected_round_start_date', {
                date: startTrainRoundDate,
              })
              : t('cpd_enrollment.round.please_select_training_round')}
          </Typography>
        </Typography>
        <Typography className="round-date-text">
          {`${t('cpd_enrollment.round_end_date')}: `}
          <Typography className="round-date-text" component="span">
            {endTrainRoundDate
              ? t('cpd_enrollment.round.selected_round_end_date', {
                date: endTrainRoundDate,
              })
              : '-'}
          </Typography>
        </Typography>
      </Box>
      <Button
        className="choose-round-button"
        onClick={onClick}
        variant={isSelectRound ? 'outlined' : 'contained'}
        startIcon={
          isSelectRound ? (
            <FontAwesomeIcon className="calendar-icon" icon="fa-regular fa-calendar-lines-pen" />
          ) : (
            <FontAwesomeIcon className="calendar-icon" icon="fa-regular fa-calendar-days" />
          )
        }
      >
        {buttonText}
      </Button>
    </ListCourseBox>
  );
};

export default ListSameCourseCpd;
